import { gql } from '@apollo/client';
import { type FC, useEffect } from 'react';
import { useOlarkScriptQuery } from '../../../../generated/hooks';
import mndUrl, { SubDomain } from '../../../../lib/mndUrl';

gql`
  query OlarkScript(
    $pressroomId: ID!
    $skipPressroom: Boolean!
    $sourceId: ID!
    $skipSource: Boolean!
  ) {
    me {
      id
      user {
        id
        name
      }
    }
    source(id: $sourceId) @skip(if: $skipSource) {
      id
      name
    }
    pressroom(id: $pressroomId) @skip(if: $skipPressroom) {
      id
      name
    }
  }
`;

const OlarkScript: FC<{ sourceId: string; pressroomId: string }> = ({ sourceId, pressroomId }) => {
  const { data } = useOlarkScriptQuery({
    variables: {
      pressroomId: pressroomId ?? '',
      skipPressroom: !pressroomId,
      sourceId: sourceId ?? '',
      skipSource: !sourceId,
    },
  });

  useEffect(() => {
    const { me, pressroom, source } = data ?? {};
    if (!me?.user || !pressroom || !source) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
window.olark||(function(c){var f=window,d=document,l=f.location.protocol=="https:"?"https:":"http:",z=c.name,r="load";var nt=function(){
f[z]=function(){
(a.s=a.s||[]).push(arguments)};var a=f[z]._={
},q=c.methods.length;while(q--){(function(n){f[z][n]=function(){
f[z]("call",n,arguments)}})(c.methods[q])}a.l=c.loader;a.i=nt;a.p={
0:+new Date};a.P=function(u){
a.p[u]=new Date-a.p[0]};function s(){
a.P(r);f[z](r)}f.addEventListener?f.addEventListener(r,s,false):f.attachEvent("on"+r,s);var ld=function(){function p(hd){
hd="head";return["<",hd,"></",hd,"><",i,' onl' + 'oad="var d=',g,";d.getElementsByTagName('head')[0].",j,"(d.",h,"('script')).",k,"='",l,"//",a.l,"'",'"',"></",i,">"].join("")}var i="body",m=d[i];if(!m){
return setTimeout(ld,100)}a.P(1);var j="appendChild",h="createElement",k="src",n=d[h]("div"),v=n[j](d[h](z)),b=d[h]("iframe"),g="document",e="domain",o;n.style.display="none";m.insertBefore(n,m.firstChild).id=z;b.frameBorder="0";b.id=z+"-loader";if(/MSIE[ ]+6/.test(navigator.userAgent)){
b.src="javascript:false"}b.allowTransparency="true";v[j](b);try{
b.contentWindow[g].open()}catch(w){
c[e]=d[e];o="javascript:var d="+g+".open();d.domain='"+d.domain+"';";b[k]=o+"void(0);"}try{
var t=b.contentWindow[g];t.write(p());t.close()}catch(x){
b[k]=o+'d.write("'+p().replace(/"/g,String.fromCharCode(92)+'"')+'");d.close();'}a.P(2)};ld()};nt()})({
loader: "static.olark.com/jsclient/loader0.js",name:"olark",methods:["configure","extend","declare","identify"]});

olark.identify('7463-669-10-6335');

olark.configure('system.hb_primary_color', '#4E49C7');
olark.configure('box.inline', true);

olark('api.chat.onBeginConversation', function() {
  olark('api.chat.sendNotificationToOperator', {body: "User: ${me.user.name} ${mndUrl(
    SubDomain.WWW,
    `/admin/press_officers/${me.user.id}/edit`,
  )}."});
  olark('api.chat.sendNotificationToOperator', {body: "Source: ${source.name}."});
  olark('api.chat.sendNotificationToOperator', {body: "Pressroom: ${source.name}."});
  olark('api.chat.sendNotificationToOperator', {body: "Publish: ${mndUrl(
    SubDomain.Publish,
    `/?admin_source_id=${source.id}`,
  )} "});
  olark('api.chat.sendNotificationToOperator', {body: "Admin: ${mndUrl(
    SubDomain.WWW,
    `/admin/source/edit/${source.id}`,
  )} "});
});
    `;
    document.body.appendChild(script);
  }, [data]);

  return null;
};

export default OlarkScript;
